<template>
  <div class="container">
    <QueryFrame
      @handlePage='handlePage'
      @handlePageSize='handlePageSize'
      :disablePage='disablePage'
      :count='count'
      :current="page"
    >
      <div slot="queryParams" class="form">
        <div class="queryContainer">
          <div class="queryItem" v-if="this.$store.state.user.roleType !== 2" >
            <label >门店:</label>
            <storeListSelect class="item" v-model="query.storeIds"></storeListSelect>
          </div>
          <div class="queryItem">
            <label >商品:</label>
            <lk-input v-model="query.goods" class="item" placeholder="请输入商品编码/通用名"></lk-input>
          </div>
          <div class="queryItem">
            <lk-button class="mr" type='primary' @click="handleSearch">查询</lk-button>
            <lk-button @click="clear">重置</lk-button>
          </div>
        </div>
      </div>
      <div slot="table">
        <div class="btns">
          <lk-button class="mr8" type='primary' @click="toOpenModal" v-if="this.$store.state.user.roleType === 2">添加换算规则</lk-button>
        </div>
        <lk-table border :columns='columns' :data='tableData'/>
      </div>
    </QueryFrame>
    <lk-modal
      v-model="isShow"
      title="添加商品"
      :loading="btnLoading"
      @on-ok="toConfirm"
    >
      <div style="margin:0 auto;width:80%;">
        <div class="flex" v-if="isShowModalSearchArea">
          <label>商品编码：</label>
          <inputSearch
            v-model.trim="searchContent"
            :columns='searchColumns'
            @getData='toGetDrugData' 
            :data='searchData'
            @selected='handleSelect'
            :reset='false'
            :maxlength='35'
            style="width:200px;"
          ></inputSearch>
        </div>
        <div style="margin:10px 0;">
          <div>{{`商品：${moadlDrugInfo.code || ''}  -${moadlDrugInfo.approvedName || ''}   -${moadlDrugInfo.approvalCode || ''}`}}</div>
          <div>{{`ERP规格：${moadlDrugInfo.goodsSpec || ''}   ERP单位：${moadlDrugInfo.minPakUnitName || ''}`}}</div>
          <div>{{`医保规格：${moadlDrugInfo.medSpec || ''}   医保单位：${moadlDrugInfo.medMinPacunt || ''}`}}</div>
        </div>
        <div>
          <div class="flex">
            换算关系：<lk-input v-model="ERPUnit" placeholder="请输入" style="width:60px;margin-right:12px;"></lk-input>ERP商品(盒)&nbsp;=&nbsp;<lk-input v-model="insUnit" style="width:60px;margin-right:12px;" placeholder="请输入"></lk-input>医保局商品(片)
          </div>
        </div>
      </div>
    </lk-modal>
  </div>
</template>
<script>
import QueryFrame from '../../components/frame/QueryFrame.vue';
import inputSearch from '../../components/InputSearch.vue'
import utils from '../../libs/utils';
import healthInsService from '../../services/healthInsManage';
import mapState from '../../mixins/mapState'; // 鉴权
import queryMixins from '../../mixins/queryMixins';
export default {
  name: 'compareCodeConvert',
  mixins: [mapState, queryMixins],
  components: {
    QueryFrame,
    inputSearch,
  },
  data() {
    return {
      insUnit: '',
      ERPUnit: 1,
      isShowModalSearchArea: false,
      btnLoading: false,
      searchContent: '',
      isShow: false,
      moadlDrugInfo: {},
      searchData: [],
      query: {},
      disablePage: false,
      tableData: [],
      columns: [
        { type: 'index', width: 60 },
        { title: '门店名称', key: 'storeName', minWidth: 116 },
        { title: '编码', key: 'code', minWidth: 116 },
        { title: '通用名', key: 'approvedName', minWidth: 116 },
        { title: '商品名', key: 'goodsName', minWidth: 116 },
        { title: '批准文号', key: 'approvalCode', minWidth: 116 },
        { title: 'ERP规格', key: 'erpSpec', minWidth: 116 },
        { title: 'ERP单位', key: 'erpUnit', minWidth: 116 },
        { title: '医保局规格', key: 'medicalSpec', minWidth: 116 },
        { title: '医保局单位', key: 'medicalUnit', minWidth: 116 },
        { title: '换算关系', key: 'converRelate', minWidth: 116 },
        { title: '操作', 
          fixed: 'right', 
          minWidth: 116,
          render: (h, params) => h('div', [
            h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.isShow = true;
                  this.isShowModalSearchArea = false;
                  this.moadlDrugInfo = params.row;
                  this.ERPUnit = 1;
                  this.numMed = '';
                },
              }
            }, '编辑'),
            h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.$Modal.confirm({
                    title: '删除对码单位换算',
                    content: '是否确认删除该商品的对码换算关系？删除后将按照1:1比例上传商品医保销售信息',
                    onOk: () => {
                      const param = {
                        id: params.row.id,
                        status: 2, // 1 启用 2 删除
                      }
                      healthInsService.updateGrainDrug(param).then(res => {
                        if (res.data.status === 200) {
                          this.$Message.success('删除成功');
                          this.getData();
                        } else {
                          this.$Message.error(res.data.error);
                        }
                      }).catch(err => {
                        utils.handleError(err);
                      })
                    }
                  })
                },
              }
            }, '删除'),
          ])
        },
      ],
      searchColumns: [
        {
          title: '商品编码',
          key: 'code',
          minWidth: 80
        },
        {
          title: '药品通用名',
          key: 'approvedName',
          minWidth: 80
        },
        {
          title: '商品名',
          key: 'goodsName',
          minWidth: 80
        },
        {
          title: '批准文号',
          key: 'approvalCode',
          minWidth: 80
        },
        {
          title: '规格',
          key: 'goodsSpec',
          minWidth: 80
        },
        {
          title: '包装单位',
          key: 'minPakUnitName',
          minWidth: 80
        },
      ],
    };
  },
  methods: {
    toOpenModal() {
      this.isShow = true;
      this.isShowModalSearchArea = true;
      this.moadlDrugInfo = {};
    },
    toConfirm() {
      const params = {
        ...this.moadlDrugInfo,
        erpSpec: this.moadlDrugInfo.goodsSpec || '',
        erpUnit: this.moadlDrugInfo.minPakUnitName || '',
        medicalSpec: this.moadlDrugInfo.medSpec || '',
        medicalUnit: this.moadlDrugInfo.medMinPacunt || '',
        numErp: this.ERPUnit,
        numMed: this.insUnit,
      }
      let submitFunc = this.isShowModalSearchArea ? healthInsService.insertGrainDrug : healthInsService.updateGrainDrug;
      submitFunc(params).then(res => {
        if (res.data.status === 200) {
          if (this.isShowModalSearchArea) {
            this.$Message.success('添加成功');
            this.isShow = false;
          } else {
            this.$Message.success('更新成功');
          }
          this.getData();
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch(err => {
        utils.handleError(err);
      })
    },
    handleSelect(obj) {
      this.moadlDrugInfo = obj;
    },
    clear() {
      this.query = {}
    },
    toGetDrugData() {
      const params = {
        name: this.searchContent,
        goodsType: 1
      }
      healthInsService.getDrugData(params).then(res => {
        if (res.data.status === 200) {
          this.searchData = res.data.data.list;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch(err => {
        utils.handleError(err);
      })
    },
    getData() {
      this.params.page = this.page;
      this.params.size = this.size;
      healthInsService.getconverRelate(this.params).then(res => {
        if (res.data.status === 200) {
          this.count = res.data.data.count;
          this.tableData = res.data.data.list;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch(err => {
        utils.handleError(err);
      })
    },
  },
  mounted() {
    this.getData();
  },
};
</script>
<style lang="less" scoped>
  .btns{
    margin-bottom: 12px
  }
  .flex {
    display: flex;
    align-items: center;
  }
</style>
